import script from "./ParentAttestationConsent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParentAttestationConsent.vue?vue&type=script&setup=true&lang=ts"

import "./ParentAttestationConsent.vue?vue&type=style&index=0&id=73c2b4dc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c2b4dc"]])

export default __exports__